export default "__VITE_ASSET__323b4aaf__"